import * as THREE from "three";
import { InstancedModel } from "../base/sceneParts.js";

export interface TreeSite { x: number; z: number; y: number; scale: number; autumn?: boolean }
const groves = new WeakMap<THREE.Object3D, () => void>();

/** A native leaf-and-branch model replaces the old intersecting solid crown spheres. */
export function addGrove(parent: THREE.Group, sites: TreeSite[]): void {
  if (!sites.length) return;
  const grove = new InstancedModel("prop.grove_elm"), up = new THREE.Vector3(0, 1, 0);
  grove.group.name = "landscape.native-grove";
  grove.setTransforms(sites.map((s, i) => new THREE.Matrix4().compose(
    new THREE.Vector3(s.x, s.y, s.z),
    new THREE.Quaternion().setFromAxisAngle(up, i * 2.39996),
    new THREE.Vector3(s.scale * (.9 + (i % 3) * .08), s.scale * (1 + (i % 4) * .045), s.scale),
  )), sites.map(s => new THREE.Color(s.autumn ? 0xe8c38c : 0xffffff)));
  parent.add(grove.group);
  groves.set(grove.group, () => { grove.dispose(); grove.group.removeFromParent(); groves.delete(grove.group); });
}

/** Retire pending loads and instances before the owner's generic mesh/material cleanup. */
export function disposeGroves(root: THREE.Object3D): void {
  const releases: (() => void)[] = [];
  root.traverse(object => { const release = groves.get(object); if (release) releases.push(release); });
  for (const release of releases) release();
}
